import type { RiskAssessmentViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';

export function toRiskAssessmentViewModel(item: RiskAssessmentViewModel): RiskAssessmentViewModel {
  return Object.assign({}, item, { name: translateTemplateName(item.name) });
}
